import type { TPagination } from '@/core/types/envelope'

export const DEFAULT_PAGE = 1
export const DEFAULT_PER_PAGE = 20

export type TPaginationParams = {
  page: number
  per_page: number
}

export const defaultPagination = (): TPaginationParams => ({
  page: DEFAULT_PAGE,
  per_page: DEFAULT_PER_PAGE,
})

/**
 * Adapter for the Ant Design Pagination shape. Falls back to
 * `total_page * per_page` when backend omits `total` (some endpoints do).
 */
export const toAntdPagination = (p: TPagination | undefined) => {
  const current = p?.page ?? DEFAULT_PAGE
  const pageSize = p?.per_page ?? DEFAULT_PER_PAGE
  const total = p?.total ?? (p?.total_page ?? 0) * pageSize
  return { current, pageSize, total }
}
